module.exports = __webpack_public_path__ + "img/zg.fa6f9a33.png";